export default "__VITE_ASSET__E_47RaLX__"